import {
  THEME_ACT_ET,
  ThemeCustomizations,
} from '@actinc/dls/styles/themeActEt';
import { CustomThemeOptions } from '@actinc/dls/types';
import { createTheme } from '@mui/material/styles';
import cloneDeep from 'clone-deep';
import { merge } from 'lodash';

export type ICustomTheme = CustomThemeOptions<ThemeCustomizations>;

export const THEME = merge(cloneDeep(THEME_ACT_ET), {
  // Custom theme overrides can go here.
  // Eventually we'll want to move these to the DLS.
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          padding: '12px 24px',
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          overflowY: 'hidden',
        },
      },
    },
    MuiDivider: {
      defaultProps: {
        'aria-hidden': true,
      },
    },
    MuiGrid: {
      styleOverrides: {
        root: {
          margin: '0px',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& legend': {
            width: 0,
          },
        },
      },
    },
  },
  palette: {
    error: { dark: '#8E0024', main: '#CC0033' },
    info: { dark: '#016089', main: '#042E60' },
    link: { main: '#042E60' },
    primary: { main: '#0077AA' },
    secondary: { dark: '#042E60', light: '#0077AA', main: '#016089' },
    success: { main: '#007B00' },
  },
} as unknown as ICustomTheme);

export const theme = createTheme(THEME);

export default theme;
